export const playTapSound = () => {
    const audio = new Audio('/sounds/tap.mp3');
    audio.currentTime = 0;
    audio.play().catch((err) => console.log('Audio playback blocked:', err));
};

export const playClickSound = () => {
    const audio = new Audio('/sounds/click.mp3');
    audio.currentTime = 0;
    audio.play().catch((err) => console.log('Audio playback blocked:', err));
}